import { GlobalState } from 'store/types';

export const currentCollectionPageNumber = (state: GlobalState) =>
  state.pages.insertProducts.singleCollection.pageNumber;
